import r from "../../node_modules/.pnpm/@heroicons_vue@2.0.13_vue@3.3.4/node_modules/@heroicons/vue/24/solid/esm/XMarkIcon.mjs";
import { defineComponent as t } from "vue";
const o = {
  white: "bg-zinc-200/40 text-zinc-800 border-zinc-300 dark:border-zinc-700 dark:bg-zinc-700/50 dark:text-zinc-200",
  red: "bg-red-200/40 text-red-800 border-red-300 dark:border-red-700 dark:bg-red-900/50 dark:border-red-900 dark:text-red-500",
  orange: "bg-orange-200/40 text-orange-800 border-orange-300 dark:border-orange-700 dark:bg-orange-900/50 dark:text-orange-500",
  yellow: "bg-yellow-200/40 text-yellow-800 border-yellow-300 dark:border-yellow-700 dark:bg-yellow-900/50 dark:text-yellow-500",
  green: "bg-green-200/40 text-green-800 border-green-300 dark:border-green-700 dark:bg-green-900/50 dark:text-green-500",
  teal: "bg-teal-200/40 text-teal-800 border-teal-300 dark:border-teal-700 dark:bg-teal-900/50 dark:text-teal-500",
  blue: "bg-blue-200/40 text-blue-800 border-blue-300 dark:border-blue-700 dark:bg-blue-900/50 dark:text-blue-500",
  sky: "bg-sky-200/40 text-sky-800 border-sky-300 dark:border-sky-700 dark:bg-sky-900/50 dark:text-sky-500",
  indigo: "bg-indigo-200/40 text-indigo-800 border-indigo-300 dark:border-indigo-700 dark:bg-indigo-900/60 dark:text-indigo-400",
  purple: "bg-purple-200/40 text-purple-800 border-purple-300 dark:border-purple-700 dark:bg-purple-900/60 dark:text-purple-400",
  pink: "bg-pink-200/40 text-pink-800 border-pink-300 dark:border-pink-700 dark:bg-pink-900/50 dark:text-pink-500",
  primary: "bg-primary-200/40 text-primary-800 border-primary-300 dark:border-primary-700 dark:bg-primary-900/50 dark:text-primary-500",
  accent: "bg-accent-200/40 text-accent-800 border-accent-300 dark:border-accent-700 dark:bg-accent-900/50 dark:text-accent-500",
  rose: "bg-rose-200/40 text-rose-800 border-rose-300 dark:border-rose-700 dark:bg-rose-900/50 dark:text-rose-500",
  emerald: "bg-emerald-200/40 text-emerald-800 border-emerald-300 dark:border-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-500"
}, a = {
  white: "text-zinc-500 border-zinc-200/40 dark:text-white hover:bg-zinc-300/60 dark:border-zinc-700 dark:hover:bg-zinc-500/40 focus:ring-zinc-400",
  red: "text-red-500 hover:bg-red-200/40 hover:text-red-500 dark:text-red-600 hover:bg-red-100 dark:hover:bg-red-600/25 focus:ring-red-400",
  orange: "text-orange-500 hover:bg-orange-200/40 hover:text-orange-500 dark:text-orange-600 hover:bg-orange-100 dark:hover:bg-orange-600/25 focus:ring-orange-400",
  yellow: "text-yellow-500 hover:bg-yellow-200/40 hover:text-yellow-500 dark:text-yellow-600 hover:bg-yellow-100 dark:hover:bg-yellow-600/25 focus:ring-yellow-400",
  green: "text-green-500 hover:bg-green-200/40 hover:text-green-500 dark:text-green-600 hover:bg-green-100 dark:hover:bg-green-600/25 focus:ring-green-400",
  teal: "text-teal-500 hover:bg-teal-200/40 hover:text-teal-500 dark:text-teal-600 hover:bg-teal-100 dark:hover:bg-teal-600/25 focus:ring-teal-400",
  blue: "text-blue-500 hover:bg-blue-200/40 hover:text-blue-500 dark:text-blue-600 hover:bg-blue-100 dark:hover:bg-blue-600/25 focus:ring-blue-400",
  sky: "text-sky-500 hover:bg-sky-200/40 hover:text-sky-500 dark:text-sky-600 hover:bg-sky-100 dark:hover:bg-sky-600/25 focus:ring-sky-400",
  indigo: "text-indigo-500 hover:bg-indigo-200/40 hover:text-indigo-500 dark:text-indigo-600 hover:bg-indigo-100 dark:hover:bg-indigo-600/25 focus:ring-indigo-400",
  purple: "text-purple-500 hover:bg-purple-200/40 hover:text-purple-500 dark:text-purple-600 hover:bg-purple-100 dark:hover:bg-purple-600/25 focus:ring-purple-400",
  pink: "text-pink-500 hover:bg-pink-200/40 hover:text-pink-500 dark:text-pink-600 hover:bg-pink-100 dark:hover:bg-pink-600/25 focus:ring-pink-400",
  primary: "text-primary-700 hover:bg-primary-300/40 hover:text-primary-500 dark:text-primary-600 hover:bg-primary-100 dark:hover:bg-primary-600/25 focus:ring-primary-400",
  accent: "text-accent-500 hover:bg-accent-200/40 hover:text-accent-500 focus:ring-accent-400",
  rose: "text-rose-500 hover:bg-rose-200/40 hover:text-rose-500 dark:text-rose-600 hover:bg-rose-100 dark:hover:bg-rose-600/25 focus:ring-rose-400",
  emerald: "text-emerald-500 hover:bg-emerald-200/40 hover:text-emerald-500 dark:text-emerald-600 hover:bg-emerald-100 dark:hover:bg-emerald-600/25 focus:ring-emerald-400"
}, g = t({
  name: "TuiBadge",
  components: { XMarkIcon: r },
  props: {
    color: {
      type: String,
      default: "white"
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    large: {
      type: Boolean,
      default: !1
    },
    dot: {
      type: Boolean,
      default: !1
    },
    border: {
      type: Boolean,
      default: !1
    },
    removable: {
      type: Boolean,
      default: !1
    },
    clickable: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["remove", "removeMousedown"],
  computed: {
    classes() {
      return {
        [o[this.color]]: !0,
        rounded: this.rounded,
        "rounded-full": !this.rounded,
        "py-0.5 pl-2.5 pr-1": this.removable && this.large,
        "py-0.5 pl-2 pr-0.5": this.removable && !this.large,
        "px-3 py-0.5": !this.removable && this.large,
        "px-2.5 py-0.5": !this.removable && !this.large,
        "text-xs": !this.large,
        "text-sm": this.large,
        border: this.border,
        "cursor-pointer select-none hover:shadow dark:hover:opacity-90": this.clickable
      };
    },
    dotClasses() {
      return {
        "mr-1.5 size-2": !0,
        "-ml-1": this.large && !this.rounded,
        "-ml-0.5": !this.large || this.large && this.rounded
      };
    },
    removeButtonClasses() {
      return a[this.color];
    }
  },
  methods: {
    handleRemoveClick(e) {
      this.removable && (e.stopPropagation(), e.preventDefault(), this.$emit("remove"));
    },
    handleRemoveMousedown(e) {
      this.removable && (e.stopPropagation(), e.preventDefault(), this.$emit("removeMousedown"));
    }
  }
});
export {
  g as default
};
//# sourceMappingURL=Badge.vue2.mjs.map
